// de_pms_reservations.ts
// Tłumaczenia dla PMS.Reservations.tsx i PMS.Reservations.Table.tsx

export const dePmsReservations = {

  title:     "Reservierungen",
  search:    "Gast oder ID suchen...",

  // ── Akcje ─────────────────────────────────────────────────────────────────
  actions: {
    newReservation:     "Neue Reservierung",
    modifyReservation:  "Reservierung aendern",
    modify:             "Aendern",
    cancelReservation:  "Reservierung stornieren",
    confirmCancellation:"Stornierung bestaetigen",
    save:               "Speichern",
    saving:             "Speichern...",
    cancelling:         "Stornieren...",
  },

  // ── Filtry statusów ───────────────────────────────────────────────────────
  status: {
    all:        "Alle",
    confirmed:  "Bestaetigt",
    inHouse:    "In-house",
    checkedOut: "Abgereist",
    cancelled:  "Storniert",
    noShow:     "No-show",
    pending:    "Ausstehend",
    waitlist:   "Warteliste",
    planned:    "Geplant",
    completed:  "Abgeschlossen",
    booked:     "Gebucht",
    active:     "Aktiv",
    blocked:    "Gesperrt",
    departing:  "Abreise heute",
    authorized: "Autorisiert",
    captured:   "Erfasst",
    inProgress: "In Bearbeitung",
  },

  // ── Typy rezerwacji ───────────────────────────────────────────────────────
  type: {
    individual: "Einzeln",
    group:      "Gruppe",
    shared:     "Geteilt",
    direct:     "Direkt",
  },

  // ── Pola formularza ───────────────────────────────────────────────────────
  fields: {
    guest:      "Gast",
    room:       "Zimmer",
    checkIn:    "Check-in",
    checkOut:   "Check-out",
    nights:     "Naechte",
    adults:     "Erwachsene",
    children:   "Kinder",
    rate:       "Rate",
    total:      "Gesamt",
    deposit:    "Kaution",
    balance:    "Saldo",
    notes:      "Notizen",
  },

  // ── Sekcja historii ───────────────────────────────────────────────────────
  history: {
    title:      "Reservierungshistorie",
    auditTrail: "Audit-Trail fuer diese Reservierung.",
    captured:   "Aus der Reservierungsverwaltung uebernommen.",
  },

  // ── Grupy rezerwacji ──────────────────────────────────────────────────────
  groups: {
    title:           "Gruppen und Veranstaltungen",
    summary:         "Gruppenuebersicht",
    create:          "Gruppe erstellen",
    edit:            "Gruppe bearbeiten",
    save:            "Gruppe speichern",
    newReservation:  "Neue Gruppenreservierung",
    editReservation: "Gruppenreservierung bearbeiten",
    groupedRooms:    "Gruppenzimmer",
    linkedEvents:    "Verknuepfte Veranstaltungen",
    primaryEvent:    "Hauptveranstaltung",
    setPrimary:      "Als Hauptveranstaltung festlegen",
    masterDetails:   "Hauptdetails und Primaerkontakt.",
    optionalEvents:  "Optionale Veranstaltungen zur Gruppenreservierung.",
    editInline:      "Reservierungsdetails direkt bearbeiten, ohne den Arbeitsbereich zu verlassen.",
    createTrack:     "Gruppenreservierungen und verknuepfte Veranstaltungen in einer Ansicht erstellen und verfolgen.",
    saved:           "Gruppenreservierung gespeichert",
    updated:         "Gruppenreservierung aktualisiert",
  },

  // ── Overbooking ───────────────────────────────────────────────────────────
  overbooking: "Ueberbuchungskontrolle",

  // ── Lista oczekujących ────────────────────────────────────────────────────
  waitlistMissingGuest: "Der Wartelisteneintrag enthaelt kein Gaesteprofil.",

  // ── Typy wydarzeń ─────────────────────────────────────────────────────────
  eventTypes: {
    meeting:       "Meeting",
    conference:    "Konferenz",
    banquet:       "Bankett",
    wedding:       "Hochzeit",
    corporateEvent:"Firmenveranstaltung",
    other:         "Andere",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    saved:                "Reservierung aktualisiert",
    cancelled:            "Reservierung storniert",
    correctionRequired:   "Bitte beheben Sie die markierten Reservierungsfehler.",
    groupCorrectionRequired:"Bitte beheben Sie die markierten Gruppenreservierungsfehler.",
    noEmail:              "Keine Empfaenger-E-Mail-Adresse fuer diese Reservierung.",
    confirmationSent:     "Bestaetigungs-E-Mail gesendet.",
    depositCaptured:      "Kaution erfasst.",
  },

} as const;

export default dePmsReservations;
